import {l} from "types/typescriptdefinisjoner_lederplan";
import {RessursFeilhåndtering} from "../RessursFeilhåndtering";
import {Strenger} from "../Strenger";
import {gettextCatalog} from "angular-gettext";
import _ from "lodash";
import {regNavn} from "../tredjepartsTjenestenavn";
import {BasisRessurs} from "../../infrastruktur/BasisRessurs";
import {Konfigurasjon} from "../../infrastruktur/Konfigurasjon";
import {IQService} from "angular";
import {Debugger} from "debug";
import IResourceArray = ng.resource.IResourceArray;

const debug: Debugger = require('debug')('ÅrshjulRessurs');

export class ÅrshjulRessurs extends BasisRessurs<l.ÅrshjulInnslagModell> {

    static regNavn = "årshjulRessurs";

    static forInjisering() {
        return [
            "$resource",
            Konfigurasjon.regNavn,
            Strenger.regNavn,
            RessursFeilhåndtering.regNavn,
            regNavn.gettext.gettextCatalog,
            regNavn.ng.$q,
            ÅrshjulRessurs
        ]
    }

    constructor($resource: ng.resource.IResourceService,
                private konfigurasjon: Konfigurasjon,
                private strenger: Strenger,
                ressursFeilhåndtering: RessursFeilhåndtering,
                gettextCatalog: gettextCatalog,
                private $q: IQService) {
        super("aarshjul",
            $resource,
            ressursFeilhåndtering,
            gettextCatalog,
            {
                'hentAlle': {method: 'GET', url: "/api/aarshjul/:gruppeId/hentalle", params: {gruppeId: "@gruppeId"}, isArray: true},
                'oppdaterAlle': {method: 'POST', url: "/api/aarshjul/:gruppeId/oppdateralle", params: {gruppeId: "@gruppeId"}, isArray: true},
                'opprett': {method: 'PUT', url: "/api/aarshjul/:gruppeId", params: {gruppeId: "@gruppeId"}}
            });
    }

    //offentlige metoder

    hentAlle(gruppeId: string) : IResourceArray<l.ÅrshjulInnslagModell>{
        debug('hentAlle', gruppeId)
        return this.ressurs['hentAlle'](
            {gruppeId: gruppeId},
            _.noop,
            this.håndterFeil(()=>this.gettextCatalog.getString("Kunne ikke hente årshjul")))
    }

    oppdaterAlle(gruppeId: string, innslag: l.ÅrshjulInnslagSpesifikasjon[]): IResourceArray<l.ÅrshjulInnslagModell> {
        debug("Oppdaterer innslag ", innslag);
        return this.ressurs['oppdaterAlle'](
            {gruppeId: gruppeId, innslag: innslag},
            _.noop,
            this.håndterFeil(()=>this.gettextCatalog.getString("Kunne ikke oppdatere årshjul. Prøv på nytt om litt.")));
    }

    /** @deprecated bruk opprettInnslag*/
    opprett(spesifikasjon, vedOk: (entitet: l.ÅrshjulInnslagModell) => void = _.noop): l.ÅrshjulInnslagModell {
        return null
    }

    opprettInnslag(gruppeId: string, spesifikasjon: l.ÅrshjulInnslagSpesifikasjon):l.ÅrshjulInnslagModell {
        debug("opprett innslag ", spesifikasjon);
        return this.ressurs['opprett'](
            _.defaults({gruppeId: gruppeId}, spesifikasjon),
            _.noop,
            this.håndterFeil(()=>this.gettextCatalog.getString("Kunne ikke oppdatere årshjul. Prøv på nytt om litt.")));
    }

    oppdater(spesifikasjon: l.ÅrshjulInnslagSpesifikasjon):l.ÅrshjulInnslagModell {
        return super.oppdater(spesifikasjon);
    }

    //statiske hjelpemetoder

}
